import api from '../utils/api';

export interface Procedure {
  id: string;
  horseId: string;
  clinicId: string;
  dischargeSummaryId?: string;
  name: string;
  description?: string;
  category?: string;
  date: string;
  performedBy?: string;
  findings?: string;
  notes?: string;
  isArchived: boolean;
  archivedAt?: string;
  archivedBy?: string;
  createdAt: string;
  updatedAt: string;
  horse?: any;
  clinic?: any;
}

export interface CreateProcedureDto {
  horseId: string;
  name: string;
  description?: string;
  category?: string;
  date: string;
  performedBy?: string;
  findings?: string;
  notes?: string;
}

export interface UpdateProcedureDto {
  name?: string;
  description?: string;
  category?: string;
  date?: string;
  performedBy?: string;
  findings?: string;
  notes?: string;
}

export const ProcedureService = {
  async getAll(params?: {
    horseId?: string;
    startDate?: string;
    endDate?: string;
    includeArchived?: boolean;
  }): Promise<Procedure[]> {
    const response = await api.get('/procedures', { params });
    return response.data;
  },

  async getById(id: string): Promise<Procedure> {
    const response = await api.get(`/procedures/${id}`);
    return response.data;
  },

  async create(data: CreateProcedureDto): Promise<Procedure> {
    const response = await api.post('/procedures', data);
    return response.data;
  },

  async update(id: string, data: UpdateProcedureDto): Promise<Procedure> {
    const response = await api.put(`/procedures/${id}`, data);
    return response.data;
  },

  async archive(id: string): Promise<Procedure> {
    const response = await api.post(`/procedures/${id}/archive`);
    return response.data;
  },

  async restore(id: string): Promise<Procedure> {
    const response = await api.post(`/procedures/${id}/restore`);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/procedures/${id}`);
  }
};


